module.exports = __webpack_public_path__ + "fonts/NotoSans-Medium.20e7c007.woff";